<template>
  <section class="sponsors">
    <div class="container">
      <h6 class="cs-textstyle-section-heading">
        Including CTOs and senior tech leaders from
      </h6>
      <div class="row justify-content-center align-items-center">
        <div class="col-6 mt-3 mt-md-0 col-md-2">
          <div class="image">
            <img src="@/assets/companylogos/Logo Colored@2x.png" />
          </div>
        </div>
        <div class="col-6 mt-3 mt-md-0 col-md-2">
          <div class="image">
            <img src="@/assets/companylogos/Logo Colored-2@2x.png" />
          </div>
        </div>
        <div class="col-6 mt-3 mt-md-0 col-md-2">
          <div class="image">
            <img src="@/assets/companylogos/Logo Colored-3@2x.png" />
          </div>
        </div>
        <div class="col-6 mt-3 mt-md-0 col-md-2">
          <div class="image">
            <img src="@/assets/companylogos/Logo Colored-4@2x.png" />
          </div>
        </div>
        <div class="col-6 mt-3 mt-md-0 col-md-2">
          <div class="image">
            <img src="@/assets/companylogos/Logo Colored-5@2x.png" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.sponsors {
  padding: 60px 0;
  text-align: center;
  overflow: hidden;
  img {
    max-width: 100%;
  }
  h6 {
    margin-bottom: 40px;
    text-transform: inherit;
  }
  .image {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 68px;
    filter: grayscale(1);

    @include media-breakpoint-up(md) {
      height: 80px;
    }
  }
}
</style>
